module.exports = __webpack_public_path__ + "static/media/avitru.2c3938cc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/avitru.png
 ** module id = 512
 ** module chunks = 0
 **/